export interface UserPracticeProfileDto {
  practiceName?: string;
  clientNumbers?: number;
  teamSize?: number;
  practiceWebsite?: string;
  hasCompletedOnboarding: boolean;
  onboardingCompletedDate?: Date;
  trialStartDate: Date;
  trialEndDate: Date;
  hasPaidPlan: boolean;
}

export interface User {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: UserRole;
  username?: string;
  phoneNumber?: string;
  birthdate?: string;
  practiceName?: string;
  emailVerified?: boolean;
  phoneNumberVerified?: boolean;
}

export enum UserRole {
  PracticeAdmin = 'PracticeAdmin',
  Practitioner = 'Practitioner',
  Client = 'Client',
  SystemAdmin = 'SystemAdmin',
}
